// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"502d696d","513":"bc4a4614"}[chunkId] + ".chunk.js";
};